import React, { useReducer,useState, useEffect } from "react";
import { useHistory, Link } from "react-router-dom";
import service from "../services";
import Loader from "../component/loader";
import TextField from "../component/TextField";
import { MinsConst, HoursConst, StampsConst, onlyNumber, DISCOUNT_USER_GROUP_OPTIONS } from "../cosntants";

//Date Picker
import DatePicker from "react-datepicker";
import CalendarIcon from "../icons/calendaricon";

//moment import
import moment from "moment-timezone";
import { useSelector, useDispatch } from "react-redux";
import PlusIcon from "../icons/plusicon";
import { CouponEditList } from "../redux/action";
import FpgDisableIcon from "../icons/fpgdisableicon";
import FpgpublishIcon from "../icons/fpgpublishicon";
import FpgDeleteIcon from "../icons/fpgdeleteicon";
import PopUpCustomAll from "../component/fpg/create/popUpCustomAll";
import CheckBox from "../component/CheckBox";
import SwitchBox from "../component/SwitchBox";
import PassIcon from "../icons/passicon";
import Sfticon from "../icons/Sfticon";
import RemoveIcon from "../icons/removeicon";
import Select from "react-select";
import dashIcon from "./../assets/images/dash.svg";
import DropdownMaster from "../component/DropdownMaster";

const reducer = (state, payload) => ({ ...state, ...payload });

const is = {
  status: 1,
  startTime: new Date(),
  HoursStart: { value: "7", label: "7" },
  MinsStart: { value: "30", label: "30" },
  StampsStart: { value: "AM", label: "AM" },
  endTime: new Date(),
  Hours: { value: "7", label: "7" },
  Mins: { value: "30", label: "30" },
  Stamps: { value: "AM", label: "AM" },
  updatedAt: "",
  updatedBy: "",
  delete: false,
  publishFilm: false,
  disable: false,
  switchbox: false,
  searchField: "",
  appliedProduct: [],
  getCouponDocs: [],
  searchlist: [],
  couponIdendifier: "",
  couponCode: "",
  eventiveCode: "",
  eventiveCouponId: "",
  userGroup: "",
  multiUse: true,
  redemptionLimit: false,
  coupomredeemed: false,
  couponUseLimit: "",
  singleCartLimit: "",
  singleCartLimitActive: false,
  singleCartLimithide: [],
  errors: {},
  errorMsg: false,
  errorMsgShow: "",
 
  labels: [
    {
      label: "DISCOUNT Detail",
      Content: "This is content for Tab 1"
    }
  ],
  type: "percentage",
  discount: "",
  perdis: "",
  loaderFlag: false,
  isCouponDetailEdited: false
};

let sub;
let localState;
export default function CouponDetail() {
  const history = useHistory();
  const [state, ds] = useReducer(reducer, is);
  const[search ,setsearchFilter]=useState([])
  const[copySearch,setsearchFiltercopy]=useState([])
  const [searchdata, setsearchdata] = useState([])
   const [field, setfield] = useState()
  const couponId = useSelector(state => state.CouponEditListEditId);
  const dispatch = useDispatch();
  const apiserve = new service();
  const [flag, setflag] = useState(false)
  const { loaderFlag, labels, updatedAt, updatedBy, status, redemoption, errors, couponCode, eventiveCode, userGroup, couponIdendifier } = state;
  const { deletePop, publish, disable, discardPopup, errorMsgShow, errorMsg, multiUse, singleCartLimithide } = state;
  const { discount, type, perdis, switchbox, getCouponDocs, searchField, appliedProduct, searchlist } = state;
  const { startTime, HoursStart, MinsStart, StampsStart, endTime, Hours, Mins, Stamps, publishFilm } = state;
  const { redemptionLimit, singleCartLimitActive, coupomredeemed, singleCartLimit, couponUseLimit, isCouponDetailEdited } = state;
  const markCouponDetailEdited = () => {
    if (couponId && !localState.isCouponDetailEdited) {
      ds({ isCouponDetailEdited: true });
    }
  };

  const updateState = (data) => {
    ds(data);
    markCouponDetailEdited();
  };

  const generateRandomCode = () => {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    const code = Array.from({ length: 15 }, () =>
      chars.charAt(Math.floor(Math.random() * chars.length))
    ).join('');
    const errorsObj = Object.assign({}, errors);
    if (errorsObj.eventiveCode) delete errorsObj.eventiveCode;
    ds({ eventiveCode: code, errors: errorsObj });
  };
  useEffect(() => {
    apiserve.sendevent("ticketCms|coupons|findProductName",{});
    subToSocket();
    if (couponId) {
      getEditDetails();
      ds({ loaderFlag: true });
    }
    return () => {
      if (sub) sub.unsubscribe();
    };
  }, []);

  useEffect(() => {
    localState = state;
  }, [state]);

  const getEditDetails = () => apiserve.sendevent("ticketCms|coupons|getDetail", { couponId });
  const deletePopupYes = () => apiserve.sendevent("ticketCms|coupons|remove", { couponId });
  const publishPopupYes = () => apiserve.sendevent("ticketCms|coupons|updateStatus", { couponId, status: 1 });
  const disablePopupYes = () => apiserve.sendevent("ticketCms|coupons|updateStatus", { couponId, status: 2 });

  const subToSocket = () => {
    try {
      sub = apiserve.getevent().subscribe(response => {
        switch (response.event) {
          case "ticketCms|coupons|getDetail":
            if (!response.error) {
              const { data } = response;
              const startTime = new Date(data.redemptionLimit?.startTime ?? new Date());
              const HoursStart = moment.tz(startTime, "US/Mountain").format("h");
              const MinsStart = moment.tz(startTime, "US/Mountain").format("mm");
              const StampsStart = moment.tz(startTime, "US/Mountain").format("A");
              const endTime = new Date(data.redemptionLimit?.endTime ?? new Date());
              const Hours = moment.tz(endTime, "US/Mountain").format("h");
              const Mins = moment.tz(endTime, "US/Mountain").format("mm");
              const Stamps = moment.tz(endTime, "US/Mountain").format("A");
              ds({
                getAlldataCouponEditList: response.data,
                couponIdendifier: data.identifier || "",
                couponCode: data.couponCode,
                eventiveCode: data.eventiveCode || "",
                eventiveCouponId: data.eventiveCouponId || "",
                userGroup: data.userGroup || "",
                endTime: endTime,
                startTime: startTime,
                HoursStart: { value: HoursStart, label: HoursStart },
                MinsStart: { value: MinsStart, label: MinsStart },
                StampsStart: { value: StampsStart, label: StampsStart },
                Hours: { value: Hours, label: Hours },
                Mins: { value: Mins, label: Mins },
                Stamps: { value: Stamps, label: Stamps },
                multiUse: data.multiUse ?? true,
                coupomredeemed: data.couponUseLimit?.isActivated || false,
                couponUseLimit: data.couponUseLimit?.limit || "",
                type: data.discount.type,
                discount: data.discount.type === "price" ? data.discount.off : "",
                perdis: data.discount.type === "percentage" ? data.discount.off : "",
                redemptionLimit: data.redemptionLimit?.isActivated || false,
                status: data.status,
                appliedProduct: data.appliedProduct || [],
                redemoption: data.totalRedemption || 0,
                switchbox: (data.appliedProduct && data.appliedProduct.length > 0) || false,
                singleCartLimitActive: data.singleCartLimit?.isActivated || false,
                singleCartLimit: data.singleCartLimit?.limit || "",
                loaderFlag: false,
                updatedAt: response?.data?.updatedAt,
                updatedBy: `${response?.data?.updatedBy?.fname} ${response?.data?.updatedBy?.lname}`,
                isCouponDetailEdited: false
              });
            } else ds({ loaderFlag: false });
            break;
          case "ticketCms|coupons|create":
            if (response.error === true) return setError(response.data.error);
            else {
              ds({ loaderFlag: false });
              apiserve.success("Discount created successfully.");
              history.push({ pathname: "/discounts-list" });
            }
            break;
          case "ticketCms|coupons|update":
            if (response.error === true) return setError(response.data.error);
            else {
              ds({ loaderFlag: false, isCouponDetailEdited: false });
              apiserve.success("Discount updated successfully.");
              getEditDetails();
            }
            break;
          case "ticketCms|coupons|findProductName":
            if (response.error) return setError(response.data.error);
            else {
              if (!response.data.docs) return
              couponFilter(response.data.docs);
              setsearchFilter(response.data.docs)
              setsearchFiltercopy(response.data.docs)
            }
            break;
          case "ticketCms|coupons|remove":
            if (response.error) return setError(response.data.error);
            apiserve.success("Discount deleted successfully.");
            history.push("/discounts-list");
            break;
          case "ticketCms|coupons|updateStatus":
            // return;
            history.push("/discounts-list");
            break;
          default:
            break;
        }
      });
    } catch (error) {
    }
  };
 
  const couponFilter = data => {
    const { searchlist, appliedProduct } = localState;
    const selectedCoupon = searchlist.map(item => item._id);
    const appliedCoupon = appliedProduct.map(item => item._id);
    const twoarray = selectedCoupon.concat(appliedProduct);
    const couponList = data.filter(
      item =>
        !(
          (selectedCoupon && selectedCoupon.includes(item._id)) ||
          (appliedCoupon && appliedCoupon.includes(item._id))
        )
    );
    ds({ loaderFlag: false, getCouponDocs: couponList, singleCartLimithide: twoarray });
  };
  const setError = err => ds({ loaderFlag: false, errorMsg: true, errorMsgShow: err });

  const handelNotAllowSpeChar = ({ target: { name, value } }) => {

    const errorsObj = Object.assign({}, errors);
    if (errorsObj[name]) delete errorsObj[name];
    updateState({ [name]: value, errors: errorsObj });
  };

  const handleChange = ({ target: { name, value, type, checked } }) => {
    if (type === "checkbox") updateState({ [name]: checked });
    else updateState({ [name]: value });
    if (checked === false) {
      updateState({ singleCartLimit: '', singleCartLimitActive: false })
    }
  };
  const discountChange = ({ target: { name, value } }) => {
    if (
      ((name === "discount" && type === "price") || (name === "perdis" && type === "percentage")) &&
      (parseInt(value) || value === "")
    ) {
      const errorsObj = Object.assign({}, errors);
      if (errorsObj[name]) delete errorsObj[name];
      updateState({ [name]: value, errors: errorsObj });
    }
  };
  const clears = () => {
    ds({
      startTime: new Date(),
      HoursStart: { value: "7", label: "7" },
      MinsStart: { value: "30", label: "30" },
      StampsStart: { value: "AM", label: "AM" },
      endTime: new Date(),
      Hours: { value: "7", label: "7" },
      Mins: { value: "30", label: "30" },
      Stamps: { value: "AM", label: "AM" },
      status: 2,
      updatedAt: "",
      updatedBy: "",
      delete: false,
      publishFilm: false,
      disable: false,
      switchbox: false,
      searchField: "",
      appliedProduct: [],
      getCouponDocs: [],
      searchlist: [],
      couponIdendifier: "",
      couponCode: "",
      eventiveCode: "",
      userGroup: "",
      multiUse: true,
      redemptionLimit: false,
      coupomredeemed: false,
      couponUseLimit: "",
      singleCartLimit: "",
      singleCartLimitActive: false,
      errors: {},
      errorMsg: false,
      errorMsgShow: "",
      type: "percentage",
      discount: "",
      perdis: "",
      loaderFlag: false
    });
    dispatch(CouponEditList(""));
  };
  const checkRequired = val => val && ((typeof val === "string" && !!val.trim()) || true);

  const getMtTime = date => {
    //Get offset from mountain time using UTC
    let ABBR = moment.tz("America/Denver").format("z");
    let offDifference = moment().utcOffset() + (ABBR === 'MDT' ? 360 : 420);
    // add that offset in date
    return moment(date).add(offDifference, "minutes").toISOString();
  };

  const verifyData = () => {
    const errors = {};
    if (!checkRequired(couponCode)) errors.couponCode = "The coupon code field is required";
    if (!checkRequired(eventiveCode)) errors.eventiveCode = "The Eventive code field is required";
    if (!userGroup) errors.userGroup = "Please select a group";
    if (type === "percentage" && !checkRequired(perdis)) errors.perdis = "The Percentage Off is required";
    if (type === "price" && !checkRequired(discount)) errors.discount = "The Discount Amount is required";
    if (switchbox && !searchlist.length && !appliedProduct.length)
      errors.appliedCoupon = "Please select products";
    if (singleCartLimitActive && !checkRequired(singleCartLimit))
      errors.singleCartLimit = "The single cart limit is required";
    if (coupomredeemed && !checkRequired(couponUseLimit))
      errors.couponUseLimit = "The coupon redeemed limit is required";
    return errors;
  };

  const submitCoupon = async e => {
    e.preventDefault();
    const errors = verifyData();
    if (!Object.keys(errors).length) {
      ds({ loaderFlag: true });
      const appliedProd = searchlist.map((item, i) => item._id);
      appliedProd.push(...appliedProduct.map((item, i) => item._id));
      const couponStartTimer = new Date(startTime);
      couponStartTimer.setHours(
        StampsStart.value === "PM" || StampsStart.value === "pm"
          ? parseInt(HoursStart.value) === 12
            ? parseInt(HoursStart.value)
            : parseInt(HoursStart.value) + 12
          : parseInt(HoursStart.value) === 12
            ? parseInt(HoursStart.value) - 12
            : parseInt(HoursStart.value),
        MinsStart.value
      );
      const couponEndTimer = new Date(endTime);
      couponEndTimer.setHours(
        Stamps.value === "PM" || Stamps.value === "pm"
          ? parseInt(Hours.value) === 12
            ? parseInt(Hours.value)
            : parseInt(Hours.value) + 12
          : parseInt(Hours.value) === 12
            ? parseInt(Hours.value) - 12
            : parseInt(Hours.value),
        Mins.value
      );
      var singleCartLimitisActivated = singleCartLimitActive === searchlist.length > 1 || singleCartLimithide.length > 1 || appliedProduct.length > 1 ? false : singleCartLimitActive;
      var singleCart = singleCartLimit === searchlist.length > 1 || singleCartLimithide.length > 1 || appliedProduct.length > 1 ? "" : singleCartLimit;
      const req = {
        status: status || 1,
        couponCode: couponCode,
        eventiveCode: eventiveCode,
        userGroup: userGroup,
        discount: { type: type, off: type === "percentage" ? perdis : discount },
        appliedProduct: switchbox === false ? [] : appliedProd,
        multiUse: multiUse,
        redemptionLimit: {
          isActivated: redemptionLimit,
          startTime: redemptionLimit === false ? "" : getMtTime(couponStartTimer),
          endTime: redemptionLimit === false ? "" : getMtTime(couponEndTimer)
        },
        couponUseLimit: { isActivated: coupomredeemed, limit: couponUseLimit },
        singleCartLimit: { isActivated: singleCartLimitisActivated, limit: singleCartLimit ? singleCart : "" }
      };
      if (couponId) {
        req.couponId = couponId;
        apiserve.sendevent("ticketCms|coupons|update", req);
      } else apiserve.sendevent("ticketCms|coupons|create", req);
    } else ds({ errors });
  };

  const closeAdminUser = () =>
    ds({ deletePop: false, publishFilm: false, disable: false, discardPopup: false });
  const validateModel = () => ds({ errorMsg: false });
  const discardPopupYes = () => history.push({ pathname: "/discounts-list" });
  const changeType = ({ target: { name } }) => {
    ds({
      type: name,
      perdis: type === "price" ? perdis : "",
      discount: type === "percentage" ? discount : ""
    });
  };

  const handleCheck = ({ target: { name, checked } }) => {
    ds({
      [name]: checked,
    });
  };

  const onSearchFilter = (e) => {
    const {name,value}= e.target
    setfield(value)
    let olddata = search.filter((item)=> {
      return item.name.toLowerCase().includes(value.toLowerCase()) 
    })
    setsearchdata(olddata)
    
  }
  const couponDocs = (e, item) => {
    setflag(true)
    const errorsObj = Object.assign({}, errors);
    if (errorsObj.appliedCoupon) delete errorsObj.appliedCoupon;
    ds({
      searchlist: [...searchlist, item],
      singleCartLimithide: [...searchlist, ...appliedProduct, item],
      getCouponDocs: [],
      searchField: "",
      errors: errorsObj
    });
    setsearchdata([])
    setfield('')
  };
    
  
  const removesearchlist = index => {
    const singleCarthide = Object.assign([], singleCartLimithide)
    singleCarthide.splice(index, 1)
    const searchlistArr = Object.assign([], searchlist);
    searchlistArr.splice(index, 1);
    ds({ searchlist: searchlistArr, singleCartLimithide: singleCarthide });
  };
  const removeappliedProduct = id => ds({ appliedProduct: appliedProduct.filter(_ => _._id !== id) });

  const handleUseChange = ({ target: { name, value } }) => {
    if (name === "multiUse") ds({ multiUse: true });
    else ds({ multiUse: false });
  };

  const handleCart = ({ target: { name, value } }) => {
    if (parseInt(value) !== 0 || value === "") {
      const errorsObj = Object.assign({}, errors);
      if (errorsObj[name]) delete errorsObj[name];
      ds({ [name]: value, errors: errorsObj });
    }
  };

  const onChangeGroup = (e, id) => {
    const { name, value } = e.target;
    this.setState({
      [name]:value
    })
  };

  return (
    <>
    <div className="right_side_wrapper">
      <ul className="fpg_admin_tab disp_flex">
        {labels ?.map((list, index) => (
          <li className="active" key={index}>
            <p className="uppercase text_left">
              <div>{list.label}</div>
              {/* <span onClick={clears}>
                <PlusIcon />
              </span> */}
            </p>
          </li>
        ))}
      </ul>
      <div className="back_date d_flex d_flex_align_center d_flex_justify_spacebt">
        <Link className="back_link" to="/discounts-list">
          <svg width="5" height="10" viewBox="0 0 5 10" fill="none">
            <path d="M5 0L0 5L5 10V0Z" fill="black" />
          </svg>
          Back to List
          </Link>
        {updatedAt && (
          <p className="update_date">
            Last Update: {moment.tz(updatedAt, "US/Mountain").format("hh:mm A")} -
              {moment.tz(updatedAt, "US/Mountain").format("MM/DD/YYYY")}
            Last Updated By: {updatedBy}
          </p>
        )}
      </div>
      <div className="product_detail_content fpg_tabcontent">
        <div className="coupon_actions d_none">
          <div className="fpg_edits_links d_flex d_flex_align_center mt_0">
            {status === 1 ? (
              <span
                className="d_flex d_flex_align_center d_flex_justify_center"
                onClick={() => ds({ disable: true })}
              >
                <FpgDisableIcon /> DISABLE
                </span>
            ) : (
                <span
                  className="d_flex d_flex_align_center d_flex_justify_center"
                  onClick={() => ds({ publishFilm: true })}
                >
                  <FpgpublishIcon /> PUBLISH
                </span>
              )}
            {redemoption < 1 && (
              <span
                className="d_flex d_flex_align_center d_flex_justify_center"
                onClick={() => ds({ deletePop: true })}
              >
                <FpgDeleteIcon />
                DELETE
                </span>
            )}
          </div>
        </div>
        <form>
          <div className="d_flex product_wrap_content">
            <div className="product_coupon_form coupon_form w_100">
              <div className="field_row horizontal_field">
                <TextField
                  type="text"
                  label="Discount Code"
                  name="couponCode"
                  value={couponCode}
                  onChange={handelNotAllowSpeChar}
                  fpgerror={errors.couponCode}
                />
              </div>
              {couponId && (
                <div className="field_row horizontal_field">
                  <TextField
                    type="text"
                    label="Identifier"
                    name="couponIdendifier"
                    value={couponIdendifier}
                    disable={true}
                  />
                </div>
              )}
              <div className="field_row horizontal_field">
                <div className="field_row_inner">
                  <label>Eventive Code</label>
                  <div className="d_flex d_flex_align_center" style={{ flex: 1, gap: '10px' }}>
                    <div className="field_input relative" style={{ flex: 1 }}>
                      <input
                        type="text"
                        name="eventiveCode"
                        value={eventiveCode}
                        onChange={handelNotAllowSpeChar}
                        autoComplete="off"
                      />
                      {errors.eventiveCode && <span className="error">{errors.eventiveCode}</span>}
                    </div>
                    {!couponId && (
                      <button
                        type="button"
                        className="small_btn active"
                        onClick={generateRandomCode}
                        style={{ flexShrink: 0 }}
                      >
                        Generate
                      </button>
                    )}
                  </div>
                </div>
              </div>
              <div className="field_row horizontal_field">
                <div className="field_row_inner">
                  <label>Group</label>
                  <div className="field_input relative" style={{ flex: 1 }}>
                    <Select
                      name="userGroup"
                      options={DISCOUNT_USER_GROUP_OPTIONS}
                      value={DISCOUNT_USER_GROUP_OPTIONS.find(opt => opt.value === userGroup) || null}
                      onChange={(selected) => {
                        const errorsObj = Object.assign({}, errors);
                        if (errorsObj.userGroup) delete errorsObj.userGroup;
                        updateState({ userGroup: selected ? selected.value : "", errors: errorsObj });
                      }}
                      placeholder="Select group..."
                      classNamePrefix="react-select"
                      styles={{
                        control: (base) => ({ ...base, minHeight: '42px', borderColor: '#d0d0d0' }),
                        menu: (base) => ({ ...base, zIndex: 9 }),
                      }}
                    />
                    {errors.userGroup && <span className="error">{errors.userGroup}</span>}
                  </div>
                </div>
              </div>
              <div className="field_row">
                <div className="field_row_inner d_flex">
                  <label htmlFor="percentage">Discount Type</label>
                  <div className="disp_flex coupon_type">
                    <div className="field_input relative">
                      <CheckBox
                        type="checkbox"
                        label="Percentage Discount"
                        id="perdiscount"
                        name="percentage"
                        checked={type === "percentage"}
                        onChange={changeType}
                      />
                      <div className="field_row ">
                        <div className="field_row_inner">
                          <label>Percentage Off</label>
                          <div className="field_input relative price_field per_field">
                            <input
                              type="text"
                              name="perdis"
                              value={perdis}
                              onChange={discountChange}
                              onKeyPress={onlyNumber}
                              autoComplete="off"
                              disabled={type !== "percentage"}
                            />
                            <span className="price_symbol left_position">%</span>
                          </div>
                        </div>
                        <span className="error">{errors.perdis}</span>
                      </div>
                    </div>
                    <div className="field_input relative">
                      <CheckBox
                        type="checkbox"
                        label="Price Discount"
                        id="discountAmount"
                        name="price"
                        checked={type === "price"}
                        onChange={changeType}
                      />
                      <div className="field_row ">
                        <div className="field_row_inner">
                          <label>Discount Amount (USD)</label>
                          <div className="field_input relative price_field amount_field">
                            <input
                              type="text"
                              name="discount"
                              value={discount}
                              onChange={discountChange}
                              onKeyPress={onlyNumber}
                              autoComplete="off"
                              disabled={type !== "price"}
                            />
                            <span className="price_symbol">$</span>
                          </div>
                        </div>
                        <span className="error">{errors.discount}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="field_row horizontal_field d_none">
                <div className="field_row_inner">
                  <label>Status</label>
                  <div className="d_flex d_flex_align_center" style={{ gap: '10px' }}>
                    <label className="switch">
                      <input
                        type="checkbox"
                        checked={status === 1}
                        onChange={() => updateState({ status: status === 1 ? 2 : 1 })}
                      />
                      <span className="slider round"></span>
                    </label>
                  </div>
                </div>
              </div>
              <div className="disp_flex d_flex_align_center switch_wrap mb_15 d_none">
                <SwitchBox
                  id="applyproduct"
                  text="Apply to specific products"
                  name="switchbox"
                  checked={switchbox}
                  onChange={handleChange}
                />
                <label className="switch_suggest">
                  (If not selected, applies to all available products)
                  </label>
              </div>
              <div className="use_checkbox_fields pb_25 d_none">
                <div className="d_flex mt_15">
                  <div className="mr_15">
                    <CheckBox
                      type="checkbox"
                      label="Multiple Use"
                      id="multiuse"
                      name="multiUse"
                      checked={multiUse ? true : false}
                      onChange={handleUseChange}
                    />
                  </div>
                  <div>
                    <CheckBox
                      type="checkbox"
                      label="Single Use"
                      id="singleuse"
                      name="singleUse"
                      checked={multiUse ? false : true}
                      onChange={handleUseChange}
                    />
                  </div>
                </div>
                <p className="suggestion">
                  (For single use, a customer can use only once. For multiple use, a customer can use
                    multiple times)
                  </p>
              </div>
              <div className="field_row d_none">
                <label>Redemption Limits</label>
                <CheckBox
                  type="checkbox"
                  label="Limit the date range when customer can redeem this coupon"
                  name="redemptionLimit"
                  checked={redemptionLimit}
                  id="redmlimit"
                  onChange={handleChange}
                />
              </div>
              {redemptionLimit && (
                <>
                <div className="date_time_range field_row d_none">
                  <div className="form_group form_group_input textfield_add_remove d_flex d_flex_align_center">
                    <div className="form_group_inner d_flex mb_0 horizontal_field d_flex_align_center">
                      <label>Date Time Range (MT)</label>
                      <div className="form_group_countdown">
                        <TextField
                          type="text"
                          name="startTime"
                          value={moment.tz(startTime, "US/Mountain").format("MM/DD/YYYY")}
                          placeholder="mm / dd / yyyy"
                        />

                        <span className="calendar_img">
                          {/* <img src={calendar} alt="calendar icon" title="calendar icon"/>   */}
                          <DatePicker
                            selected={startTime}
                            onChange={date => ds({ startTime: date })}
                            minDate={moment().toDate()}
                            placeholder="mm/dd/yyyy"
                            customInput={
                              <span className="calendar">
                                <CalendarIcon />
                              </span>
                            }
                          />
                        </span>

                        <Select
                          options={HoursConst}
                          value={HoursStart}
                          name="HoursStart"
                          placeholder="7"
                          onChange={e => ds({ HoursStart: e })}
                        />
                        <Select
                          options={MinsConst}
                          value={MinsStart}
                          name="MinsStart"
                          placeholder="30"
                          onChange={e => ds({ MinsStart: e })}
                        />
                        <Select
                          options={StampsConst}
                          value={StampsStart}
                          name="StampsStart"
                          placeholder="AM"
                          onChange={e => ds({ StampsStart: e })}
                        />
                      </div>
                    </div>
                    <span className="dash_icon">
                      <img src={dashIcon} />
                    </span>
                    <TextField
                      type="text"
                      name="countDownDate"
                      value={moment.tz(endTime, "US/Mountain").format("MM/DD/YYYY")}
                      placeholder="mm / dd / yyyy"
                    />
                    <span className="calendar_img">
                      {/* <img src={calendar} alt="calendar icon" title="calendar icon"/>   */}
                      <DatePicker
                        selected={endTime}
                        onChange={date => ds({ endTime: date })}
                        minDate={moment().toDate()}
                        placeholder="mm/dd/yyyy"
                        customInput={
                          <span className="calendar">
                            <CalendarIcon />
                          </span>
                        }
                      />
                    </span>
                    <Select
                      options={HoursConst}
                      value={Hours}
                      name="Hours"
                      placeholder="7"
                      onChange={e => ds({ Hours: e })}
                    />
                    <Select
                      options={MinsConst}
                      value={Mins}
                      name="Mins"
                      placeholder="30"
                      onChange={e => ds({ Mins: e })}
                    />
                    <Select
                      options={StampsConst}
                      value={Stamps}
                      name="Stamps"
                      placeholder="AM"
                      onChange={e => ds({ Stamps: e })}
                    />
                  </div>
                </div>
                </>
              )}
              <div className="field_row d_none">
                <CheckBox
                  type="checkbox"
                  label="Limit the total number of times this coupon can be redeemed across the Sundance site"
                  name="coupomredeemed"
                  checked={coupomredeemed}
                  id="limitcoupon"
                  onChange={handleChange}
                />
                <span className="error"></span>
                {coupomredeemed && (
                  <>
                  <TextField
                    type="text"
                    placeholder=""
                    name="couponUseLimit"
                    value={couponUseLimit}
                    onChange={handleCart}
                    onKeyPress={onlyNumber}
                  />
                  <span className="error">{errors.couponUseLimit}</span>
                  </>
                )}
              </div>

              {searchlist.length > 1 || singleCartLimithide.length > 1 || appliedProduct.length > 1 ? "" :
                <div className="field_row d_none">
                  {switchbox &&
                    <>
                    <CheckBox
                      type="checkbox"
                      label="Limit the total number of items this coupon can be applied to in one single cart (applies to one specific product for the coupon and not valid for multiple products in one coupon)"
                      name="singleCartLimitActive"
                      checked={singleCartLimitActive}
                      id="single"
                      onChange={handleChange}
                    />
                    <span className="error">{}</span>
                    {singleCartLimitActive && (
                      <>
                      <TextField
                        type="text"
                        placeholder=""
                        name="singleCartLimit"
                        value={singleCartLimit}
                        onChange={handleCart}
                        onKeyPress={onlyNumber}
                      />
                      <span className="error">{errors.singleCartLimit}</span>
                      </>
                    )} </>}
                </div>
              }
            </div>
          </div>
          <div className="text_center field_row w_100 buttons_outer">
            <button className="uppercase" onClick={() => ds({ discardPopup: true })} type="button">
              CANCEL
              </button>
            <button className={`uppercase ${(!couponId || isCouponDetailEdited) ? 'active' : ''}`} onClick={e => submitCoupon(e)} disabled={loaderFlag || (couponId && !isCouponDetailEdited)}>
              SAVE
              </button>
          </div>
        </form>
      </div>
    </div>
    {deletePop && (
      <PopUpCustomAll
        HeaderName="Deleted?"
        insideDetails="You are about to delete an item and this action is permanent"
        insideData="Do you want to proceed?"
        popupState={closeAdminUser}
        yesPopUp={deletePopupYes}
      />
    )}
    {publishFilm && (
      <PopUpCustomAll
        HeaderName="Publish Changes"
        insideDetails="Saving the current changes will publish it to the production site"
        insideData="Do you want to proceed?"
        popupState={closeAdminUser}
        yesPopUp={publishPopupYes}
      />
    )}
    {disable && (
      <PopUpCustomAll
        HeaderName="Disable?"
        insideDetails="You are about to disable an item, which will temporarily make it unavailable on the production site"
        insideData="Do you want to proceed?"
        popupState={closeAdminUser}
        yesPopUp={disablePopupYes}
      />
    )}
    {discardPopup && (
      <PopUpCustomAll
        HeaderName="Discard Changes?"
        insideDetails="Leaving this page without saving will discard all changes"
        insideData="Do you want to proceed?"
        popupState={closeAdminUser}
        yesPopUp={discardPopupYes}
      />
    )}
    <div className={`user_popup ${errorMsg ? "active" : ""}`}>
      <span className="popup_overlay"></span>
      <div className="sundance_popup_detail box_shadow approve_success_popup bg_white">
        <div className="approve_popup_header text_center relative">
          <p>{errorMsgShow}</p>
        </div>
        <div className="content">
          <div className="field_row text_center">
            <button className="small_btn active" onClick={validateModel}>
              OK
              </button>
          </div>
        </div>
      </div>
    </div>
    {loaderFlag && <Loader />}
    </>
  );
}